/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const getAllWecomDepartmentsApi = params => {
  return axios.get(`${base}/wecom/get_all_departments`, {params})
}

export const getAllActiveUsersApi = params => {
  return axios.get(`${base}/wecom/get_all_active_users`, {params})
}



// WEBPACK FOOTER //
// ./src/views/wecom/wecom.api.js